import {UserRole} from '@core/models/Enums/UserRole';
import {RouteInfo} from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '',
    title: 'PRINCIPAL',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    role: [
      UserRole.Admin,
      UserRole.Medico,
      UserRole.Particular,
    ],
    submenu: [],
  },
  {
    path: 'dashboard',
    title: 'MIS RECETAS',
    iconType: 'material-icons-outlined',
    icon: 'space_dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [
      UserRole.Paciente
    ],
    submenu: [],
  },
  {
    path: 'patient/patient-list',
    title: 'PACIENTES',
    iconType: 'material-icons-outlined',
    icon: 'face',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [
      UserRole.Medico, UserRole.Particular,
    ],
    submenu: [],
  },
  {
    path: 'prescription/prescription-list',
    title: 'RECETAS',
    iconType: 'material-icons-outlined',
    icon: 'assignment',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.Admin, UserRole.Medico, UserRole.Particular],
    submenu: [],
  },
  {
    path: 'prescription/prescription-supply',
    title: 'SURTIR RECETA',
    iconType: 'material-icons-outlined',
    icon: 'done_outline',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.Empleado_Farmacia, UserRole.Responsable_Farmacia],
    excludeRegions: ['ES'],
    submenu: [],
  },
  {
    path: '',
    title: 'ADMINISTRACION',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    role: [
      UserRole.Admin, UserRole.Supervisor_Sucursales,
      UserRole.Responsable_Farmacia
    ],
    submenu: [],
  },
  {
    path: 'admin/user-list',
    title: 'PERSONAL',
    iconType: 'material-icons-outlined',
    icon: 'group',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [
      UserRole.Admin, UserRole.Supervisor_Sucursales,
      UserRole.Responsable_Farmacia
    ],
    excludeRegions: ['ES'],
    submenu: [],
  },
  {
    path: 'doctor/doctor-list',
    title: 'MEDICOS',
    iconType: 'material-icons-outlined',
    icon: 'supervised_user_circle',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [
      UserRole.Admin,
      UserRole.Supervisor_Sucursales, UserRole.Responsable_Farmacia
    ],
    submenu: [],
  },
  {
    path: 'doctor/registration-requests',
    title: 'SOLICITUDES REGISTRO',
    iconType: 'material-icons-outlined',
    icon: 'assignment_ind',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [
      UserRole.Admin,
      UserRole.Supervisor_Sucursales,
      UserRole.Responsable_Farmacia
    ],
    submenu: [],
  },
  {
    path: 'branch/branch-list',
    title: 'SUCURSALES',
    iconType: 'material-icons-outlined',
    icon: 'location_city',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [
      UserRole.Admin,
      UserRole.Supervisor_Sucursales,
      UserRole.Particular
    ],
    submenu: [],
  },
  // {
  //   path: 'reports/reports-list',
  //   title: 'Reportes',
  //   iconType: 'fas fa-chart-bar',
  //   icon: '',
  //   class: '',
  //   groupTitle: false,
  //   badge: '',
  //   badgeClass: '',
  //   role: ['All'],
  //   submenu: [],
  // },
  {
    path: '',
    title: 'CONFIGURACION',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    role: [
      UserRole.Admin
    ],
    submenu: [],
  },
  /*{
    path: 'catalogs/catalogs-list',
    title: 'CATALOGOS',
    iconType: 'material-icons-outlined',
    icon: 'folder',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [
      UserRole.Admin,
      UserRole.Medico,
    ],
    submenu: [],
  },*/
  {
    path: 'catalogs/catalogs-list-v2',
    title: 'ACCESOS',
    iconType: 'material-icons-outlined',
    icon: 'vpn_key',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [
      UserRole.Admin
    ],
    submenu: [],
  },
  // {
  //   path: '',
  //   title: 'Perfil',
  //   iconType: '',
  //   icon: '',
  //   class: '',
  //   groupTitle: true,
  //   badge: '',
  //   badgeClass: '',
  //   role: ['All'],
  //   submenu: [],
  // },
  // {
  //   path: 'user/profile',
  //   title: 'Perfil',
  //   iconType: 'material-icons-outlined',
  //   icon: 'account_circle',
  //   class: '',
  //   groupTitle: false,
  //   badge: '',
  //   badgeClass: '',
  //   role: ['All'],
  //   submenu: [],
  // },
  {
    path: 'patient/health-event-list',
    title: 'EVENTOS',
    iconType: 'material-icons-outlined',
    icon: 'assignment',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.Paciente],
    submenu: [],
  },
];
